export * from "./applicationConfig";
